/**
 * Javascript for the select2 form-widget.
 *
 * @author: Andrew Hayes <andrew.hayes@therealbuzzgroup.com>
 */

(function($) {
    $(document).ready(function () {

        // construction stuff
        var selector = '.js-select2:not([id*="__prefix__"])';

        function construct_select2_widget($element) {
            var opts = {};
            if ($element.attr('data-bootstrap') === '1') {
                opts.theme = 'bootstrap';
            }
            $element.select2(opts);
        }

        // construct on page load
        $(selector).each(function() {
            construct_select2_widget($(this));
        });

        // construct on dynamic node insertion
        var observer = new MutationObserver(function(mutations, observer) {
            var i, j;
            for (i = 0; i < mutations.length; i++) {
                if (
                    mutations[i].type === 'childList' &&
                    mutations[i].addedNodes &&
                    mutations[i].addedNodes.length > 0
                ) {
                    for (j = 0; j < mutations[i].addedNodes.length; j++) {
                        $(mutations[i].addedNodes[j]).find(selector).addBack(selector).each(function() {
                            construct_select2_widget($(this));
                        });
                    }
                }
            }
        });
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });

})(window.jQuery || window.$ || (window.django && window.django.jQuery));
